/**
 * Normalise IDs only at filter-option boundaries. NetSuite endpoints are not
 * consistent about returning internal IDs as numbers or numeric strings, while
 * manufacturer filters legitimately use names as IDs.
 */
export function normalizeId(id) {
  if (id == null || typeof id === "number") return id;
  if (String(id).trim() === "") return id;

  const parsed = Number(id);
  return Number.isNaN(parsed) ? id : parsed;
}

export function areFilterIdsEqual(left, right) {
  return normalizeId(left) === normalizeId(right);
}

/**
 * Round-trip a multi-select filter array through one URL query param.
 *
 * The comma is the separator, so every entry is `encodeURIComponent`ed first — a
 * manufacturer *name* is a legal entry (`manufacturer_name` doubles as the id), and a
 * name containing a comma or an ampersand must not split or corrupt the list. A plain
 * `values.join(",")` breaks exactly there.
 *
 * `decodeFilterList("")` is `[]`, so an absent param and an empty selection read the
 * same.
 */
export function encodeFilterList(values) {
  return (values || [])
    .map((value) => encodeURIComponent(String(value)))
    .join(",");
}

export function decodeFilterList(raw) {
  if (!raw) return [];

  return String(raw)
    .split(",")
    .filter(Boolean)
    .map((part) => normalizeId(decodeURIComponent(part)));
}
